<template>  
  <v-layout row wrap class="pa-5"> 

    <v-flex xs1/>                   
    <v-flex xs2>
      <v-combobox
        :items="periodList"
        label="Select Start Period"
        item-text="text"
        v-model="selectedStartDate"
        single-line
        return-object
        v-on:change="startPeriodChanged"
      ></v-combobox>
    </v-flex>
    <v-flex xs1/>    
    <v-flex xs2>
      <v-combobox
          :items="periodList"
          label="Select End Period"
          item-text="text"
          v-model="selectedEndDate"
          single-line
          return-object
          v-on:change="endPeriodChanged"
      ></v-combobox>
    </v-flex>
    <v-flex xs6/>                   
    <v-flex xs6 >
      <v-treeview
        :open.sync="openSync"
        :items="items"
        item-key="id"
        :dense="dense"
        :selectable="selectable"
        :activatable="activatable"
        :hoverable="hoverable"
        :open-on-click="openOnClick"
        :selected-color="selectedColor"
        :color="color"
        :shaped="shaped"
        :rounded="rounded"
      >
        <template v-slot:prepend="{ item }">
          
          {{ item.saleCount}}
        </template>      
        <template v-slot:append="{ item }">
         
                {{ item.totalAmountFormatted }} &#9;{{ item.currencyText}} Avg = {{ item.averageAmountFormatted }} 
                
        </template>
      </v-treeview> 
    </v-flex>    
    <v-flex xs6> 
          <chartPie 
          :chart-title="this.salePieTitle" 
          :series="this.salePieSeries"/>
    </v-flex>                                        
  </v-layout>  
</template>

<script>

import ChartPie from '../../components/charts/ChartPie.vue';

const GET_SALE_REPORT_API_URL = 'reports/salesReport';
const PERIODS_API_URL = 'definitions/periods';

export default {
  name: 'ReportByProduct',
  components:{
    chartPie: ChartPie
  },
  props: {
  },
  data: () => ({
    salePieTitle: "Sales by Countries",
    salePieSeries:[{
          name: 'Sales',
          colorByPoint: true,
          data: [{}]
        }],
    periodList: [],
    selectedEndDate: {},
    selectedStartDate: {},
    bankAccountBalances: [],
    openSync: [100],
    items: [
      
      {
        id: 100,
        name: 'All Sales Amount',  
        totalAmountFormatted : '',
        averageAmountFormatted : '',
        saleCount : 0,
        avarageAmount : '',
        currencyText : '',
        children : []
      }   
    ],
    dense: false,
    selectable: false,
    activatable: false,
    hoverable: true,
    openOnClick: true,
    shaped: false,
    rounded: false,
    color: 'primary',
    selectedColor: 'accent',
    selectedColors: [
      'accent',
      'teal',
      'red',
      'success',
      'warning lighten-2',
    ],
  }),
  watch: {   
  },
  created() {    
    this.getPeriods();  
  },
  computed: {
  },
  methods: {

    async getPeriods(){
      await this.getPerformancePeriodList();
    },
    async getPerformancePeriodList(){     
        this.$axios.get(this.$apiurl + PERIODS_API_URL)
            .then(response => {
                this.periodList = response.data;
                this.selectedStartDate = this.periodList[11];
                this.selectedEndDate =  this.periodList[0];
                this.getSalesReport();
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    startPeriodChanged(item){    
      this.selectedStartDate = item;  
      if(this.selectedEndDate){
        this.getSalesReport();
      }      
    },
    endPeriodChanged(item){
      this.selectedEndDate = item;
      if(this.selectedStartDate){
        this.getSalesReport();
      }  
    },
  
    getSalesReport(){     
        this.$axios.get(this.$apiurl + GET_SALE_REPORT_API_URL, { 
            params: {
              startDate: this.selectedStartDate.startDate,
              endDate: this.selectedEndDate.endDate
            }                                               
          })
            .then(response => {             
              this.fillReport(response.data);
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    fillReport(data){  

      const saleMap = new Map(Object.entries(data.resultMap));                
      this.salePieSeries[0].data = [];
      saleMap.forEach((value, key) => {
        this.salePieSeries[0].data.push({name:key , y: value})
      }); 
      this.items[0].totalAmountFormatted = data.totalAmountFormatted;
      this.items[0].saleCount = data.saleCount;
      this.items[0].averageAmountFormatted = data.averageAmountFormatted;
      this.items[0].currencyText = data.currencyText;
      this.items[0].children = data.children;
                
    },
  
  }
}
</script>
<style scoped>
.v-icon.outlined {
    border: 1px solid black;
    border-radius:10%;
    height: 30px;
    width: 30px;
}
</style>